export default "__VITE_ASSET__BsiBCKuX__"